<template>
  <!-- ヘッダーコンテンツ: アカウント名 -->
  <div class="l-header-config">
    <a class="c-btn c-btn--square c-btn--config u-wh64" href="#account" @click="imageClick()">
      <div class="c-icon u-wh26 c-icon--white c-icon--alpha70">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <use xlink:href="/assets/img/sprite.svg#gear" />
        </svg>
      </div>
    </a>
    <div class="l-header-config__list">
      <div class="c-balloon">
        <div class="c-balloon__arrow"></div>
        <div class="c-balloon__close" @click="closeClick()">
          <div class="c-icon u-wh22 c-icon--gray-3">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#close-thin" />
            </svg>
          </div>
        </div>
        <div class="c-balloon-title">
          <p class="c-balloon-title__label">設定<span v-show="headerData.isSystemAdminEdit">（SystemAdmin）</span></p>
        </div>
        <ul class="c-balloon-list is-active">
          <li class="c-balloon-list__item c-balloon-list__item--ellipsis">
            <dl>
              <dt class="u-text-black-2">{{ headerData.role }}</dt>
              <dd>{{ headerData.loginId }}</dd>
            </dl>
          </li>
          <li v-if="headerData.isSiteAdmin" class="c-balloon-list__item c-balloon-list__item c-balloon-list__item--ellipsis">
            <a :href="headerData.teamUrl">チーム設定・ユーザーの追加・削除</a>
          </li>
          <li class="c-balloon-list__item c-balloon-list__item c-balloon-list__item--ellipsis">
            <a :href="headerData.profileUrl">個人設定</a>
          </li>
          <li class="c-balloon-list__item c-balloon-list__item c-balloon-list__item--ellipsis">
            <a :href="headerData.logoutUrl" onclick="event.preventDefault(); document.getElementById('logout-form').submit();">ログアウト</a>
            <form
              id="logout-form"
              :action="headerData.logoutUrl"
              method="POST"
              style="display: none;"
            ><input type="hidden" name="_token" :value="csrfToken" /></form>
          </li>
          <li v-show="headerData.isSystemAdminEdit" class="c-balloon-list__item c-balloon-list__item c-balloon-list__item--ellipsis">
            <a @click="returnAdminView">管理者ビューへ戻る</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    headerData: Object,
  },
  emits: ["open"],
  data: function () {
    return {
      config: null,
      csrfToken: this.headerData.csrfToken,
    }
  },
  mounted: function () {
    this.config = $('.l-header-config__list');
  },
  methods: {
    isOpen: function(){
      return this.config.hasClass('is-active');
    },
    imageClick: function(){
      if (!this.isOpen()) {
        this.open();
      } else {
        this.close();
      }
    },
    closeClick: function(){
      this.close();
    },
    open: function(){
      this.config.addClass('is-active');
      this.$emit('open');
    },
    close: function(){
      this.config.removeClass('is-active');
    },
    returnAdminView: function() {
      axios.post('/api/return-systemadmin')
        .then(_res => {
          location.href = '/coins-admin/account';
        })
        .catch(_e => {
        });
    }
  }
};
</script>